import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrManager } from 'ng6-toastr-notifications';
import { DatabaseService } from 'src/_services/DatabaseService';
import { DialogComponent } from 'src/app/dialog.component';
import { ImageModuleComponent } from 'src/app/image-module/image-module.component';
import { sessionStorage } from 'src/app/localstorage.service';


@Component({
    selector: 'app-inventory-detail',
    templateUrl: './inventory-detail.component.html',
    styleUrls: ['./inventory-detail.component.scss']
})
export class InventoryDetailComponent implements OnInit {

    status: any;
    skLoading: boolean = false;

    data: any = {};
    login_data: any = [];
    inventory_id: any;

    inventory_detail: any = [];
    login_dr_id: any;
    loader: any;
    inventory_item: any = [];
    inventoryType: any;
    url: any = '';
    pdfurl: any = '';

    totalAmt: number = 0;
    totalQuantity: number = 0;
    totalPoint: number = 0;
    document_no: any;
    filter: any = {}




    constructor(public route: ActivatedRoute, public serve: DatabaseService, public toast: ToastrManager, public dialog: MatDialog, public session: sessionStorage, public dialogs: DialogComponent, public router: Router, public alert: DialogComponent,) {
        this.url = serve.uploadUrl + 'gift_gallery/';
        this.pdfurl = serve.uploadUrl + 'doc_catalogue/';


        this.login_data = this.session.getSession();
        this.login_data = this.login_data.value.data;


        if (this.login_data.access_level != '1') {
            this.login_dr_id = this.login_data.id;
        }

        this.route.params.subscribe(params => {
            console.log(params)
            // this.inventory_id = this.serve.crypto(params['id'], false);
            this.document_no = params.document_no;
            this.serve.currentUserID = params.id
            this.inventoryType = this.route.queryParams['_value']['inventory_type']
            // this.serve.currentUserID = this.serve.crypto(params['id'], false)
            this.status = this.route.queryParams['_value']['status'];

        });
        this.inventoryDetail();
    }

    ngOnInit() {


    }






    inventoryDetail() {
        this.loader = 1;
        this.skLoading = true;
        this.filter.document_no = this.document_no;
        this.filter.inventory_type = this.inventoryType;
        setTimeout(() => {
            this.serve.post_rqst({ 'filter': this.filter }, "Influencer/get_inventory_detail").subscribe((result => {
                if (result['statusCode'] == 200) {
                    this.skLoading = false;
                    this.inventory_detail = result['inventory_detail'][0];
                    this.inventory_item = this.inventory_detail['parts'];
                } else {
                    setTimeout(() => {
                        this.loader = '';
                    }, 700);
                    this.skLoading = false;
                    this.toast.errorToastr(result['statusMsg'])
                }
            }))
        }, 700);
    }


    deleteOrderitem(inventory_id, index) {
        this.alert.confirm("You want to delet this item !").then((result) => {
            if (result) {
                this.serve.post_rqst({ 'id': inventory_id }, "Order/primaryOrderDeleteItem")
                    .subscribe((result => {
                        if (result['status'] == 200) {
                            this.toast.successToastr('Item Deleted Successfully');
                            this.inventoryDetail();
                        } else {
                            this.inventoryDetail();
                            this.toast.errorToastr(result['status'])
                        }
                    }))
            }
        })
    }






    back() {
        window.history.go(-1);
    }


    exportPdf() {
        this.loader = 1;
        this.skLoading = true;
        let id = { 'id': this.inventory_id }
        this.serve.post_rqst(id, "Order/exportOrderPdf").subscribe((result) => {
            if (result['statusCode'] == 200) {
                this.skLoading = false;
                window.open(this.serve.uploadUrl + 'orderPdf/' + result['file_name']);
                setTimeout(() => {
                    this.loader = '';

                }, 700);
            } else {
                setTimeout(() => {
                    this.loader = '';

                }, 700);
                this.skLoading = false;
                this.toast.errorToastr(result['statusMsg'])
            }
        }
            , err => {
                this.skLoading = false;

            }
        )
    }

    goToImage(image) {
        const dialogRef = this.dialog.open(ImageModuleComponent, {
            panelClass: 'Image-modal',
            data: {
                'image': image,
                'type': 'base64'
            }
        });
        dialogRef.afterClosed().subscribe(result => {
        });

    }




    editDetails() {

        this.router.navigate(['inventory-list/add-inventory'], { queryParams: { 'type': '', 'network': '', 'id': this.inventory_detail.dealer_id, 'inventory_detail':JSON.stringify(this.inventory_detail) } });
    }







}

